import React from 'react';

import { QStack } from '@captivateiq/quotient';

import { HeaderAIShell } from './HeaderAIShell';
import { TabsAIShell } from './TabsAIShell';

export const AIShell = () => {
  return (
    <div
      style={{
        height: '100dvh',
        display: 'flex',
        flexShrink: 0,
        width: '100%',
      }}
    >
      <QStack
        direction="column"
        sx={{
          alignItems: 'stretch',
          borderLeft: {
            xs: 'none',
            md: '1px solid',
          },
          borderLeftColor: 'grey.200',
          justifyContent: 'flex-start',
          maxHeight: '100dvh',
          minHeight: '100dvh',
          width: '100%',
        }}
      >
        <HeaderAIShell />
        <TabsAIShell />
      </QStack>
    </div>
  );
};
